module.exports = __webpack_public_path__ + "img/1_028.6ee0ff30.jpg";